module.exports = __webpack_public_path__ + "img/logo.801de2ee.png";